<template>
    <component-redirecting/>
</template>

<script>

import api from '@/api'
import axios from 'axios'
import ComponentRedirecting from '@/components/default/shared/ComponentRedirecting'

export default {
  components: { ComponentRedirecting },
  name: 'NewEventFromLMS',
  methods: {
    redirect () {
      const courseId = this.$route.params.courseId
      const moduleId = this.$route.params.moduleId
      const domain = this.$route.params.domain
      axios({
        method: 'get',
        url: `${api.classroom}/events/lms/${courseId}/${moduleId}/${domain}`
      })
        .then(response => {
          let eventId = response.data.id
          this.$router.replace({ name: 'ebs-event-show', params: { id: eventId } })
        })
        .catch(() => {
          this.$router.replace({ name: 'ebs-event-list' })
        })
    }
  },
  mounted () {
    this.redirect()
  }
}
</script>
